import db from "../_root/apiBridge";
import { timestamp } from "../_root/apiBridge";

export async function getAdminChapterEditInsert(query: any): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      db.collection("chapters")
        .add({...query, audit_created: timestamp.fromDate(new Date())})
        .then(function (refDoc) {
          resolve({
            id: refDoc.id,
          });
        }).catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
}

export async function getAdminChapterEditUpdate(
  id: string,
  query: any
): Promise<any> {
  return new Promise((resolve, reject) => {
    db.collection("chapters")
      .doc(id)
      .update({...query, audit_updated: timestamp.fromDate(new Date())})
      .then(() => {
        resolve({
          id,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export async function  getAdminChapterEditElim(id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      db.collection("chapters")
        .doc(id)
        .delete()
        .then(() => {
          resolve({
            id,
          });
        }).catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
}
